import type { ChangelogEntry } from "../types";

/** Book møte viser vertenes ledige tid i en ukekalender. */
export const BOOK_MOTE_KALENDER_2026_10: ChangelogEntry = {
  id: "2026-10-28-book-mote-kalender",
  date: "2026-10-28",
  title: "Se når vertene er ledige før du booker møtet",
  summary: "Book møte har fått en ukekalender som viser når vertene er ledige. Du klikker en grønn rute for å velge tid.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "Ukekalender i Book møte",
          kind: "forbedret",
          featureFlag: "feature_crm_leads_moter",
          body: "I stedet for å velge dato og klokkeslett først viser Book møte en uke av gangen med ledige tider i grønt. Som standard ser du alle vertene samlet og hvor mange som er ledige. Velg en vert over kalenderen for å se bare den vertens kalender. Klikk en ledig rute for å velge tid, og velg vert under hvis flere er ledige.",
        },
      ],
    },
  ],
};
